import {
  IMasterSlotsResponse,
  ShopMaxPerDay,
  IShopPerDayResponse,
  IShopPerTimeResponse,
  ShopMaxPerTime,
  PerDaySlotsForCustomData,
  ITeamPerDayResponse,
  ITeamPerTimeResponse,
  TeamMaxPerTime,
  ITeamPerTimePerTeamResponse,
  ITechniciansPerDayResponse,
  ITechniciansAllTeamResponse,
  TechnicianSlotsPerTeam,
  ITechnicianPerTeamResponse,
  ITransportSlotsResponse,
  IRemotePerDayResponse,
  IRemotePerTimeResponse,
  ISlotsPerDayResponse,
  SlotsPerDay,
  IActivateIndicatorsResponse
} from './../models/slot-management.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment  } from './util.service';
import { Store } from '@ngrx/store';
import { DealerState } from '../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../store/dealer/dealer.selectors';
import { TransportationType } from '@signal/asp-data-commons';

@Injectable({
  providedIn: 'root'
})
export class SlotService {
  private apiRoot: string;

  constructor(private readonly http: HttpClient,
    private readonly dealerState: Store<DealerState>) {
    this.apiRoot = environment.aspAvailabilityApi;
  }

  getMasterSlots(availabilityType: string): Observable<IMasterSlotsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/masterTimeSlots`).pipe(
        map((data: IMasterSlotsResponse) => {
          return data;
        })
      );
    }));
  }

  getActivateIndicators(availabilityType: string, indicatorType: string): Observable<IActivateIndicatorsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/indicator/${indicatorType}`).pipe(
        map((data: IActivateIndicatorsResponse) => {
          return data;
        })
      );
    }));
  }

  updateActivateIndicators(indicator: any, availabilityType: string, indicatorType: string): Observable<IActivateIndicatorsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/indicator/${indicatorType}`, {'indicator':indicator}).pipe(
        map((data: IActivateIndicatorsResponse) => {
          return data;
        })
      );
    }));
  }

  /*Slot capacity */

  updateShopMaxTotal(slots: ShopMaxPerDay[], availabilityType: string): Observable<IShopPerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/shop/day`, slots).pipe(
        map((data: IShopPerDayResponse) => {
          return data;
        })
      );
    }));
  }

  /* Implements forkJoin to reduce req size*/
  updateShopMaxSlots(slots: any, availabilityType: string): Observable<IShopPerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      var callList: any= [];
      slots.forEach(slotPerDay=> {
        if (slotPerDay.dayOfWeek) {
        const call1 = this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/shop/time`, slotPerDay);
        callList.push(call1);
        }
      });
      return forkJoin(callList).pipe(map((responses: ISlotsPerDayResponse[]) => {
      
        return { data: {slotsPerDay: responses.map(x => x.data)}, status: responses[0].status};
      }));
    }));
  }

  getShopMaxTotal(availabilityType: string): Observable<IShopPerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/shop/day`).pipe(
        map((data: IShopPerDayResponse) => {
          return data;
        })
      );
    }));
  }

  getShopMaxSlots(availabilityType: string): Observable<IShopPerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/shop/time`).pipe(
        map((data: IShopPerTimeResponse) => {
          return data;
        })
      );
    }));
  }

  /*Team capacity */

  updateTeamMaxTotal(slots: PerDaySlotsForCustomData[], availabilityType: string): Observable<ITeamPerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/team/day`, slots).pipe(
        map((data: ITeamPerDayResponse) => {
          return data;
        })
      );
    }));
  }

   /* Implements forkJoin to reduce req size*/
  updateTeamMaxSlots(slots: TeamMaxPerTime, availabilityType: string): Observable<ITeamPerTimePerTeamResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      var callList: any= [];
      slots.slotsPerDay.forEach(slotPerDay=> {
        if (slotPerDay.dayOfWeek) {
        const call1 = this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/team/time/${slots.teamId}`, slotPerDay);
        callList.push(call1);
        }
      });
      return forkJoin(callList).pipe(map((responses: ITeamPerTimePerTeamResponse[]) => {
        
        return { data:{teamId: slots.teamId, slotsPerDay: responses.map(x=>x.data.slotsPerDay[0])} , status: responses[0].status};
    }));
  }));
  }



  getTeamMaxTotal(availabilityType: string): Observable<ITeamPerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/team/day`).pipe(
        map((data: ITeamPerDayResponse) => {
          return data;
        })
      );
    }));
  }

  getTeamMaxSlots(availabilityType: string): Observable<ITeamPerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/team/time`).pipe(
        map((data: ITeamPerTimeResponse) => {
          return data;
        })
      );
    }));
  }

  /* Technician Capacity */
  getTechnicianTotal(availabilityType: string): Observable<ITechniciansPerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/technician/day`).pipe(
        map((data: ITechniciansPerDayResponse) => {
          return data;
        })
      );
    }));
  }

  getTechnicianSlots(availabilityType: string): Observable<ITechniciansAllTeamResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/technician/team/all`).pipe(
        map((data: ITechniciansAllTeamResponse) => {
          return data;
        })
      );
    }));
  }

  updateTechnicianTotal(slots: PerDaySlotsForCustomData[], availabilityType: string): Observable<ITechniciansPerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/technician/day`, slots).pipe(
        map((data: ITechniciansPerDayResponse) => {
          return data;
        })
      );
    }));
  }

  updateTechnicianSlots(slots: TechnicianSlotsPerTeam, availabilityType: string): Observable<ITechnicianPerTeamResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/technician/team/${slots.teamId}`, slots.perDay).pipe(
        map((data: ITechnicianPerTeamResponse) => {
          return data;
        })
      );
    }));
  }

  /* transport capacity */
  getTransportSlots(availabilityType: string): Observable<ITransportSlotsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/transport`).pipe(
        map((data: ITransportSlotsResponse) => {
          return data;
        })
      );
    }));
  }

  updateTransportSlots(slots: PerDaySlotsForCustomData[], availabilityType: string): Observable<ITransportSlotsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/transport`, slots).pipe(
        map((data: ITransportSlotsResponse) => {
          return data;
        })
      );
    }));
  }

  /* Transport Capacity */
  updateTransportMaxTotal(transport: TransportationType, slots: ShopMaxPerDay[], availabilityType: string): Observable<IRemotePerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/${this.getTransport(transport)}/day`, slots).pipe(
        map((data: IRemotePerDayResponse) => {
          return data;
        })
      );
    }));
  }

  updateTransportMaxSlots(transport: TransportationType, slots: any, availabilityType: string): Observable<IRemotePerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      var callList: any= [];
      slots.forEach(slotPerDay=> {
        const call1 = this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/${this.getTransport(transport)}/time`, slotPerDay);
        callList.push(call1);
      });
      return forkJoin(callList).pipe(map((responses: ISlotsPerDayResponse[]) => {
        
        return { data: {slotsPerDay: responses.map(x => x.data)}, status: responses[0].status};
      }));
    }));
  }

  getTransportMaxTotal(transport: TransportationType, availabilityType: string): Observable<IRemotePerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/${this.getTransport(transport)}/day`).pipe(
        map((data: IRemotePerDayResponse) => {
          return data;
        })
      );
    }));
  }

  getTransportMaxSlots(transport: TransportationType, availabilityType: string): Observable<IRemotePerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/${this.getTransport(transport)}/time`).pipe(
        map((data: IRemotePerTimeResponse) => {
          return data;
        })
      );
    }));
  }
  /* TXM Team Capacity */
  updateTxmTeamMaxTotal(slots: ShopMaxPerDay[], availabilityType: string): Observable<IRemotePerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/txmTeam/day`, slots).pipe(
        map((data: IRemotePerDayResponse) => {
          return data;
        })
      );
    }));
  }

  updateTxmTeamMaxSlots(slots: any, availabilityType: string): Observable<IRemotePerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      var callList: any= [];
      slots.forEach(slotPerDay=> {
        const call1 = this.http.post(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/txmTeam/time`, slotPerDay);
        callList.push(call1);
      });
      return forkJoin(callList).pipe(map((responses: ISlotsPerDayResponse[]) => {
       
        return { data: {slotsPerDay: responses.map(x => x.data)}, status: responses[0].status};
      }));
    }));
  }

  getTxmTeamMaxTotal( availabilityType: string): Observable<IRemotePerDayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/txmTeam/day`).pipe(
        map((data: IRemotePerDayResponse) => {
          return data;
        })
      );
    }));
  }

  getTxmTeamMaxSlots(availabilityType: string): Observable<IRemotePerTimeResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}slots/${dealerCode}/${availabilityType}/txmTeam/time`).pipe(
        map((data: IRemotePerTimeResponse) => {
          return data;
        })
      );
    }));
  }

  private getTransport(transport: TransportationType) {
    return  transport.toLocaleLowerCase();
  }

}
